// view animation
gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', function() {
    const titleIn = document.querySelectorAll('.c_common__title span');
    titleIn.forEach(item => {
        ScrollTrigger.create({
            trigger: item,
            start: "top 90%",
            onEnter: () => {
                item.classList.add("js-show");
            }
        });
    });
    const fade = document.querySelectorAll('.c_common__fade');
    fade.forEach(item => {
        ScrollTrigger.create({
            trigger: item,
            start: "top 90%",
            onEnter: () => {
                item.classList.add("js-show");
            }
        });
    });

    function applyFadeInWithScrollTrigger(fadeInItems, timeout) {
        fadeInItems.forEach(item => {
            ScrollTrigger.create({
                trigger: item,
                start: "top 90%",
                onEnter: () => {
                    setTimeout(() => {
                        item.classList.add("js-show");
                    }, timeout);
                }
            });
        });
    }
    const fadeIn = document.querySelectorAll('.c_common__fadeIn');
    const fadeInDelay1 = document.querySelectorAll('.c_common__fadeInDelay.--delay1');
    const fadeInDelay2 = document.querySelectorAll('.c_common__fadeInDelay.--delay2');
    const fadeInDelay3 = document.querySelectorAll('.c_common__fadeInDelay.--delay3');
    const fadeInDelay4 = document.querySelectorAll('.c_common__fadeInDelay.--delay4');
    const fadeInDelay5 = document.querySelectorAll('.c_common__fadeInDelay.--delay5');
    const fadeInDelay6 = document.querySelectorAll('.c_common__fadeInDelay.--delay6');
    const timeDelay = 250;
    applyFadeInWithScrollTrigger(fadeIn, 0);
    applyFadeInWithScrollTrigger(fadeInDelay1, 0 * timeDelay);
    applyFadeInWithScrollTrigger(fadeInDelay2, 1 * timeDelay);
    applyFadeInWithScrollTrigger(fadeInDelay3, 2 * timeDelay);
    applyFadeInWithScrollTrigger(fadeInDelay4, 3 * timeDelay);
    applyFadeInWithScrollTrigger(fadeInDelay5, 4 * timeDelay);
    applyFadeInWithScrollTrigger(fadeInDelay6, 5 * timeDelay);
});


//faq - accordion
jQuery(function($) {
    $('.c_top-faq__item').on('click', function () {
        $(this).children('.c_top-faq__item-text').slideToggle();
        $(this).children('.c_top-faq__item-head').toggleClass('js-open');
        return false;
    });
});

//top - area tab change
jQuery(function($) {
    $('.c_top-area__wrap.js-show').show();
    $('.c_top-area__tag').on('click', function () {
        $('.c_top-area__wrap').fadeOut(0);
        $($(this).attr('href')).fadeIn(500);
        $('.c_top-area__tag').removeClass('js-current');
        $(this).addClass('js-current');
        return false;
    });
});

//banner - swiper
const bannerSwiper = new Swiper('.c_banner__swiper', {
    loop: true, //最後→最初に戻るループ再生を有効に
    autoplay: { 
        delay: 3000, //何秒ごとにスライドを動かすか
        stopOnLastSlide: false, //最後のスライドで自動再生を終了させるか
        disableOnInteraction: true, //ユーザーの操作時に止める
        reverseDirection: false, //自動再生を逆向きにする
    },
    speed: 1000, //表示切り替えのスピード
    pagination: {
        el: ".c_banner__swiper-pagination", //paginationのclass
        clickable: true, //クリックでの切り替えを有効に
        type: "bullets" //paginationのタイプ (※2)
    },
    navigation: {
        prevEl: ".c_banner__swiper-button-prev", //戻るボタンのclass
        nextEl: ".c_banner__swiper-button-next" //進むボタンのclass
    },
    allowTouchMove: true, // スワイプで表示の切り替えを無効に
    breakpoints: { //画面幅による表示枚数と余白の指定
        320: {
            centeredSlides: true, //中央寄せ
            slidesPerView: 1,
            spaceBetween: 10,
        },
        375: {
            centeredSlides: true, //中央寄せ
            slidesPerView: 1.2,
            spaceBetween: 15,
        },
        500: {
            centeredSlides: true, //中央寄せ
            slidesPerView: 2.1,
            spaceBetween: 15,
        },
        740: {
            slidesPerView: 2,
            spaceBetween: 10,
            centeredSlides: false, //中央寄せ
        },
        1000: {
            slidesPerView: 3,
            spaceBetween: 16,
        }
    }
});


